import { call, put } from 'redux-saga/effects'

import { getCompanyAccount } from '../apiModules/companyAccounts'
import * as companyAccountEntities from '../reducks/companyAccounts'

export function* fetchCompanyAccountEntitySaga(companySlug) {
  const response = yield call(getCompanyAccount, companySlug)

  yield put(companyAccountEntities.addItem(response.result.id, response.result))

  return response
}
